import { Command } from 'commands/Commands';

export class Publish extends Command {
  type: string = 'BlogArticle.Publish';
  priority: number = 150;
}

export class Approve extends Command {
  type: string = 'BlogArticle.Approve';
  priority: number = 150;
}

export class Reject extends Command {
  type: string = 'BlogArticle.Reject';
  priority: number = 150;
}
